import React from "react";
import PropTypes from "prop-types";
import * as actions from "../../auth/AuthActions";
import NotificationSystem from "react-notification-system";
import { View } from "react-template";
import { connect } from "react-redux";
import App from "./App";

class AppModule extends View {
  constructor(props) {
    super(props);
    this.state = { loadToken: false };
  }

  token() {
    this.props.dispatch(
      actions.load(
        res => {
          this.setState({ loadToken: true });
        },
        error => {
          error === "forbidden"
            ? this.redirect("/403")
            : console.log("token error");
        }
      )
    );
  }

  getNotificationSystem = () => this.notificationSystem;

  getContent = () => {
    if (this.isRoutePublic()) {
      return this.props.children;
    } else {
      if (!this.state.loadToken) {
        this.token();
        return null;
      } else if (this.props.auth.loggedIn) {
        return <App {...this.props}>{this.props.children}</App>;
      }
      this.redirect("/login");
    }
  };

  isRoutePublic() {
    return this.isFatherPublic() || this.props.routes.last().public;
  }

  isFatherPublic() {
    return (
      this.props.routes.filter(r => r !== this.props.routes.last() && r.public)
        .length > 0
    );
  }

  getNotificationSystem = () => this.notificationSystem;

  getChildContext() {
    return {
      notificationSystem: this.getNotificationSystem
    };
  }

  render() {
    return (
      <div>
        <NotificationSystem ref={n => this.setNotification(n)} />
        {this.getContent()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

export default connect(mapStateToProps)(AppModule);

AppModule.childContextTypes = {
  notificationSystem: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/containers/AppModule.js